// @flow
import { defineMessages } from 'react-intl';
import { notificationTypes, templateTypes } from '~/core/constants/recipes';

export default defineMessages({
    [notificationTypes.email]: {
        id: 'recipes.email',
        defaultMessage: 'Email'
    },
    [notificationTypes.push]: {
        id: 'recipes.mobile',
        defaultMessage: 'Push (iOS & Android)'
    },
    [notificationTypes.sms]: {
        id: 'recipes.text',
        defaultMessage: 'Text'
    },
    [templateTypes.notifyMotion]: {
        id: 'recipes.notify-motion',
        defaultMessage: 'Notify me when a motion sensor detects motion'
    },
    [templateTypes.notifyOpenContact]: {
        id: 'recipes.notify-open-contact',
        defaultMessage: 'Notify me when a window or door sensor is opened'
    },
    [templateTypes.notifyClosedContact]: {
        id: 'recipes.notify-closed-contact',
        defaultMessage: 'Notify me when a window or door sensor is closed'
    },
    [templateTypes.modifyPlugWhenMotion]: {
        id: 'recipes.modify-plug-when-motion',
        defaultMessage: 'Turn a plug ON or OFF when a motion sensor detects motion'
    },
    [templateTypes.modifyPlugWhenOpenContact]: {
        id: 'recipes.modify-plug-when-open-contact',
        defaultMessage: 'Turn a plug ON or OFF when a window or door sensor is opened'
    },
    [templateTypes.modifyPlugWhenClosedContact]: {
        id: 'recipes.modify-plug-when-closed-contact',
        defaultMessage: 'Turn a plug ON or OFF when a window or door sensor is closed'
    },
    [templateTypes.modifyLightWhenMotion]: {
        id: 'recipes.modify-light-when-motion',
        defaultMessage: 'Turn a light ON or OFF when a motion sensor detects motion'
    },
    [templateTypes.modifyLightWhenOpenContact]: {
        id: 'recipes.modify-light-when-open-contact',
        defaultMessage: 'Turn a light ON or OFF when a door or window sensor is opened'
    },
    [templateTypes.modifyLightWhenClosedContact]: {
        id: 'recipes.modify-light-when-closed-contact',
        defaultMessage: 'Turn a light ON or OFF when a door or window sensor is closed'
    },
    [templateTypes.motionSensorHeatingMode]: {
        id: 'recipes.motion-sensor-heating-mode',
        defaultMessage: 'Set heating when a motion sensor detects motion'
    },
    [templateTypes.contactSensorOpenedHeatingMode]: {
        id: 'recipes.contact-sensor-opened-heating-mode',
        defaultMessage: 'Set heating when a window or door sensor is opened'
    },
    [templateTypes.contactSensorClosedHeatingMode]: {
        id: 'recipes.contact-sensor-closed-heating-mode',
        defaultMessage: 'Set heating when a window or door sensor is closed'
    },
    [templateTypes.hiveButtonPressedActivePlugOnOff]: {
        id: 'hive-button-pressed-activeplug-on-off',
        defaultMessage: 'Turn a plug ON or OFF when a Hive Button is pressed'
    },
    [templateTypes.hiveButtonDoublePressedActivePlugOnOff]: {
        id: 'hive-button-double-pressed-activeplug-on-off',
        defaultMessage: 'Turn a plug ON or OFF when a Hive Button is double pressed'
    },
    [templateTypes.hiveButtonLongHoldPressedActivePlugOnOff]: {
        id: 'hive-button-long-hold-pressed-activeplug-on-off',
        defaultMessage: 'Turn a plug ON or OFF when a Hive Button is long-hold pressed'
    },
    [templateTypes.hiveButtonPressedLightOnOff]: {
        id: 'hive-button-pressed-light-on-off',
        defaultMessage: 'Turn a light ON or OFF when a Hive Button is pressed'
    },
    [templateTypes.hiveButtonDoublePressedLightOnOff]: {
        id: 'hive-button-double-pressed-light-on-off',
        defaultMessage: 'Turn a light ON or OFF when a Hive Button is double pressed'
    },
    [templateTypes.hiveButtonLongHoldPressedLightOnOff]: {
        id: 'hive-button-long-hold-pressed-light-on-off',
        defaultMessage: 'Turn a light ON or OFF when a Hive Button is long-hold pressed'
    },
    [templateTypes.hiveButtonPressedHeatingMode]: {
        id: 'hive-button-pressed-heating-mode',
        defaultMessage: 'Set heating when a Hive Button is pressed'
    },
    [templateTypes.hiveButtonDoublePressedHeatingMode]: {
        id: 'hive-button-double-pressed-heating-mode',
        defaultMessage: 'Set heating when a Hive Button is double pressed'
    },
    [templateTypes.hiveButtonLongHoldPressedHeatingMode]: {
        id: 'hive-button-long-hold-pressed-heating-mode',
        defaultMessage: 'Set heating when a Hive Button is long-hold pressed'
    },
    always: {
        id: 'recipes.always',
        defaultMessage: 'Always'
    },
    cancel: {
        id: 'recipes.cancel',
        defaultMessage: 'Cancel',
        description: 'Button label to cancel an action'
    },
    confirm: {
        id: 'recipes.confirm',
        defaultMessage: 'Confirm',
        description: 'Button label to confirm an action'
    },
    confirmDeleting: {
        id: 'recipes.confirm-deleting',
        defaultMessage: 'Confirm deleting action',
        description: 'Message to show to confirm a recipe to be deleted'
    },
    deleting: {
        id: 'recipes.deleting',
        defaultMessage: 'Deleting...',
        description: 'Message to show when a recipe is being deleted'
    },
    for: {
        id: 'recipes.for',
        defaultMessage: 'for {duration}',
        description: 'to display a recipe duration (e.g. for 5 minutes)'
    },
    notifyMeBy: {
        id: 'recipes.notify-me-by',
        defaultMessage: 'Notify me by {list}'
    },
    scheduled: {
        id: 'recipes.scheduled',
        defaultMessage: 'Scheduled'
    },
    turnPlugOff: {
        id: 'recipes.turn-plug-off',
        defaultMessage: 'Turn {deviceName} off',
        description: 'Turn a plug off'
    },
    turnPlugOn: {
        id: 'recipes.turn-plug-on',
        defaultMessage: 'Turn {deviceName} on',
        description: 'Turn a plug on'
    },
    turnLightOff: {
        id: 'recipes.turn-light-off',
        defaultMessage: 'Turn {deviceName} off',
        description: 'Turn a light bulb off'
    },
    turnLightOn: {
        id: 'recipes.turn-light-on',
        defaultMessage: 'Turn {deviceName} on',
        description: 'Turn a light bulb on'
    },
    setHeatingToSchedule: {
        id: 'recipes.set-heating-to-schedule',
        defaultMessage: 'Set {deviceName} to Schedule',
        description: 'Set a thermostat to schedule'
    },
    setHeatingToManual: {
        id: 'recipes.set-heating-to-manual',
        defaultMessage: 'Set {deviceName} to Manual at {degrees}°',
        description: 'Boost a thermostat'
    },
    boostHeating: {
        id: 'recipes.boost-heating',
        defaultMessage: 'Boost {deviceName} to {degrees}° for {duration}',
        description: 'Boost a thermostat'
    },
    turnHeatingOff: {
        id: 'recipes.turn-heating-off',
        defaultMessage: 'Set {deviceName} to Off',
        description: 'Turn a thermostat off'
    },
    updating: {
        id: 'recipes.updating',
        defaultMessage: 'Updating...',
        description: 'Message to show when enabling/disabling the recipe'
    },
    whenDetectsMotion: {
        id: 'recipes.when-detects-motion',
        defaultMessage: 'When {deviceName} detects motion'
    },
    whenContactIsClosed: {
        id: 'recipes.when-contact-is-closed',
        defaultMessage: 'When {deviceName} is closed'
    },
    whenContactIsOpened: {
        id: 'recipes.when-contact-is-opened',
        defaultMessage: 'When {deviceName} is opened'
    },
    whenButtonIsPressed: {
        id: 'recipes.when-button-is-pressed',
        defaultMessage: 'When {deviceName} is pressed'
    },
    whenButtonIsDoublePressed: {
        id: 'recipes.when-button-is-double-pressed',
        defaultMessage: 'When {deviceName} is double pressed'
    },
    whenButtonIsLongHoldPressed: {
        id: 'recipes.when-button-is-long-hold-pressed',
        defaultMessage: 'When {deviceName} is long-hold pressed'
    },
    addRecipe: {
        id: 'recipes.add-recipe',
        defaultMessage: 'Add a new action'
    },
    when: {
        id: 'recipes.when',
        defaultMessage: 'When'
    },
    then: {
        id: 'recipes.then',
        defaultMessage: 'Then'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/intl.js